import React from 'react';
import styled from 'styled-components';

import css from 'css';
import PointerDown from 'images/PointerDown';

/**
 * Props:
 * - label [string] text shown when nothing is selected
 * - options [array of objects] [{name: '', value: ''}]
 * - value [string/int] current value
 * - onChange [function] 
 */
export default props => {
    const { label, options, value, onChange, white, id, name } = props;

    const valueLabel = options && options.reduce((acc, item) => (String(item.value) === String(value) ? item.name : acc), label);

    return (
        <Select className={props.className} white={white}>
            <div>
                {valueLabel}
                <PointerDown color={white ? '#fff' : css.colors.blue} />
                <select value={value} onChange={onChange} id={id} name={name}>
                    {label && <option value="" >{label}</option>}
                    {options && options.map((option, i) => <option key={i} value={option.value}>{option.name}</option> )}
                </select>
            </div>
        </Select>
    );
}

const Select = styled.div`
    > div {
        position:relative;
        color: ${css.colors.main};
        display: flex;
        align-items: center;
        justify-content:center;
        width:220px;
        height:48px;
        border:2px solid ${css.colors.blue};
        ${props => props.white ? `
            color: #fff;
            border:2px solid #fff;
        ` : ``}

        select {
            appearance: none;
            font-size:16px;
            outline: none;
            border:none;
            color: ${css.colors.main};
            opacity:0;
            position:absolute;
            width:100%;
            height:100%;
            top:0;
            left:0;
            cursor:pointer;
        }
        svg {
            width: 14px;
            height: 9px;
            position: absolute;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
        }
    }
`



// WEBPACK FOOTER //
// ./src/partials/formElements/Select.js